import { createActionUtils, IAction, IActionJavaData, IActionWebConfig } from "@droid/project-v2-interface"
import { a11yActionNamespace } from "../a11y-namespace"
import { ulid } from "ulid"
import { UI } from "./UI"
import { Log } from "@fanfanlo"

const fileLog = new Log(false, '[IActionA11yNodeExecute]')
fileLog.pause = true
fileLog.childrenPaused = true

const type = `${a11yActionNamespace}node-execute`
fileLog.log('[IActionA11yNodeExecute] type:', type)

// 简化的节点属性键类型
export type a11yNodePropertyKeys = string

// 简化的节点信息接口
export interface IA11yNodeInfo {
    [key: string]: any
}

// 简化的节点操作接口
export interface NodeAction {
    name: string
    value: string
}

export interface IActionA11yNodeJavaData extends IActionJavaData {
    info?: IA11yNodeInfo
    action?: NodeAction
    setText?: string
    selectedProperties: a11yNodePropertyKeys[]
    regexProperties: IA11yNodeRegexProperties
    wait: IA11yNodeWait
}

export interface IA11yNodeRegexProperties {
    text?: string
    contentDescription?: string
    hintText?: string
}

export interface IA11yNodeWait {
    time: number
    interval: number
    invisible: boolean
}

export interface IActionA11yNodeWebConfig extends IActionWebConfig {
    // A11y Node Execute Action 特有的 Web 配置
}

export interface IActionA11yNodeExecute extends IAction<IActionA11yNodeJavaData, IActionA11yNodeWebConfig> {
    javaData: IActionA11yNodeJavaData
}

function createDefaultData(): IActionA11yNodeExecute {
    fileLog.log('[createDefaultData] 开始创建默认数据')
    const ulidValue = ulid()
    const data = {
        
        ulid: ulidValue,
        uuid: '',
        ownerUuid: '',
        currentVersion: 0,
        type,
        javaData: {
            selectedProperties: [],
            regexProperties: {},
            wait: {
                time: 0,
                interval: 0,
                invisible: false
            },
            action: { name: 'click', value: 'click' }
        },
        createdAt: 0,
        updatedAt: 0,
        authorUuid: '',
    }
    fileLog.log('[createDefaultData] data:', JSON.stringify(data))
    return data
}

function init() {
    fileLog.log('[init] node-execute 初始化')
}

export const actionA11yNodeExecuteUtils = createActionUtils(type, init, createDefaultData, UI)
